export default {
  months: {
    complete: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    abbreviation: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
  },
  infinite_scroll: {
    empty_text: 'No items found',
    initial_loading: 'Loading...',
    load_more: 'Loading more...',
    no_more: 'No more items to load',
  },
}
